import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatSnackBar } from '@angular/material';
import { SharedModalInfoListComponent } from '../../../../../shared/modal-info-list/modal-info-list.component';
import { PixKeyType } from '../../../models/key-type.enum';
import { PixKeysService } from '../../keys.service';
import { EventTypes } from '../../../../../shared/EventTypes';
import { AppEventDispatcher } from '../../../../../utils/AppEventDispatcher';
import { Util } from '../../../../../utils/util';
import { Auth } from '../../../../../autentication/Auth';
import { PixKey } from '../../../models/key.model';

@Component({
	selector: 'app-pix-keys-create-validation-code',
	templateUrl: './validation-code.component.html',
	styleUrls: ['./validation-code.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixKeysCreateValidationCodeComponent implements OnInit {

	public headerTxt = '';
	public selectedPixKey: PixKey;
	public guid = '';

	constructor(
		private router: Router,
		public dialog: MatDialog,
		private route: ActivatedRoute,
		private pixCreateService: PixKeysService,
		private snackBar: MatSnackBar,
	) {}

	ngOnInit(): void {
		this.guid = Util.generateGUID();
		this.selectedPixKey = this.pixCreateService.getPixKey();
		this.checkParams() ? '' : this.goToList();
		this.sendCode();
	}

	checkParams(): boolean {
		if (!this.selectedPixKey || !this.selectedPixKey.codigo === undefined || !this.selectedPixKey.tipoChave) {
			return false;
		} else {
			return true;
		}
	}

	sendCode() {
		if (this.selectedPixKey && this.selectedPixKey.tipoChave === PixKeyType.EMAIL) {
			this.sendEmail();
		} else if (this.selectedPixKey && this.selectedPixKey.tipoChave === PixKeyType.PHONE) {
			this.sendSms();
		}
	}

	resendCode() {
		if (this.selectedPixKey.tipoChave === PixKeyType.EMAIL) {
			this.showSnack('Enviamos um código para seu e-mail.');
			this.sendEmail();
		} else if (this.selectedPixKey.tipoChave === PixKeyType.PHONE) {
			this.showSnack('Enviamos um código para o número.');
			this.sendSms();
		}
	}

	sendSms() {
		this.pixCreateService.postValidate(this.selectedPixKey.codigo, this.selectedPixKey.tipoChave).subscribe(result => {}, error => {
			this.handleError(error);
		});
	}

	sendEmail() {
		this.pixCreateService.postValidate(this.selectedPixKey.codigo, this.selectedPixKey.tipoChave).subscribe(result => {}, error => {
			this.handleError(error);
		});
	}

	notReceivedValidationCode() {
		if (this.selectedPixKey.tipoChave === PixKeyType.EMAIL) {
			this.notReceivedValidationCodeEmail();
		}
		if (this.selectedPixKey.tipoChave === PixKeyType.PHONE) {
			this.notReceivedValidationCodePhone();
		}
	}

	submitValidationCode($event: any) {
		const code = $event;

		this.pixCreateService.putValidade(this.selectedPixKey.codigo, this.selectedPixKey.tipoChave, this.guid, code).subscribe(data => {
			if (data.Sucesso) {
				this.addCodeValidationSignature(code);
				this.goToAssignature();
			}
		});
	}

	addCodeValidationSignature(code: string) {
		Auth.codigoValidacao = code;
	}

	notReceivedValidationCodePhone() {
		this.dialog.open(SharedModalInfoListComponent, {
			width: '360px',
			data: {
				title: 'Você não recebeu o código por SMS?',
				text: 'Se mesmo assim você ainda não conseguir receber o código, fale conosco através do e-mail sac@omni.com.br',
				listItem: [
					'Verifique se seu número de telefone foi digitado corretamente',
					'Verifique suas mensagens de SMS e veja se o código chegou',
					'Verifique se a rede do seu celular está ativa e o modo avião foi desativado',
					'Se o sinal de rede estiver fraco, procure um lugar que tenha um sinal melhor.'
				],
				btnName: 'Fechar',
			}
		});
	}

	notReceivedValidationCodeEmail() {
		this.dialog.open(SharedModalInfoListComponent, {
			width: '360px',
			data: {
				title: 'Você não recebeu o código por e-mail?',
				text: 'Se mesmo assim você ainda não conseguir receber o código, fale conosco através do e-mail sac@omni.com.br',
				listItem: ['Verifique se o endereço de e-mail foi digitado corretamente.', 'Verifique suas caixas de mensagens e também a caixa de spam.'],
				btnName: 'Fechar',
			}
		});
	}

	showSnack(msg: string) {
		this.snackBar.open(msg, 'Ok', { duration: 2000, });
	}

	public get keyType(): typeof PixKeyType {
		return PixKeyType;
	}

	goToList = () => this.router.navigate(['pix/chaves/listar/']);
	goToAssignature = () => this.router.navigate(['pix/chaves/criar/assinatura/']);
	cancel = () => this.router.navigate(['pix/chaves/criar']);
	handleError = (error) => AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/keys/create/validation-sms/validation-code.component.ts